import { Outlet, Link } from 'react-router-dom'

import { useAuth, useFetchData, useToast } from 'hooks'
import { localStorageKeys } from 'config/localStorageKeys'
import { useTranslation } from 'react-i18next'

const PersistLogin = () => {
	const { setAuth } = useAuth()
	const { t } = useTranslation()

	useFetchData({
		name: 'fetchMe',
		endpoint: '/me/',
		options: {
			onSuccess: (res: any) => {
				const me = res.data

				setAuth((prev: any) => ({ ...prev, user: me }))

				if (
					localStorage.getItem(localStorageKeys.showBankToast) === 'true' &&
					!me.bank_info_account
				) {
					useToast({
						type: 'error',
						message: (
							<Link to="/profile">
								{t('Please click here to fill your banking account information')}
							</Link>
						)
					})()
					localStorage.setItem(localStorageKeys.showBankToast, 'false')
				}
			}
		}
	})

	return <Outlet />
}

export default PersistLogin
